<template>
  <div class="goods">
    <v-head :title="title"></v-head>
    <div class="contentOffLine">
      <van-cell title="缴费年数" required is-link @click="show = true" :value="yearsName" />
      <van-field label="缴费金额" v-model="params.amount" input-align="right" placeholder="缴费金额根据缴费年数自动生成" disabled>
        <template #button v-if="params.amount">元</template>
      </van-field>
      <div v-if="userInfo.memberNo" style="color:red;font-size: 0.4rem;margin: bottom 0.2rem;;font-weight: 600">
        您在续费成功后将会在会员证中体现，请谨慎选择</div>
      <van-cell v-if="userInfo.memberNo" title="您要续费的机构" required
        :value="getRecommendBranchName(params.recommendUnitId)" is-link
        @click="showRecommendBranchPicker(recommendUnitId, undefined)" />
      <van-field name="invoiceApplyradio" label="是否开票">
        <template #input>
          <van-radio-group v-model="invoiceApplyradio" direction="horizontal" @change="changeInvoiceApplyRadio">
            <template v-for="item in invoiceApplyradioEnum">
              <van-radio :name="item.value" :key="item.value">{{
                item.name
                }}</van-radio>
            </template>
          </van-radio-group>
        </template>
      </van-field>
      <div v-if="invoiceApplyradio == '2'">
        <van-field label="发票类型" class="cellRoadDiv">
          <template #input>
            <van-radio-group v-model="params.invoiceType" direction="horizontal" @change="onInoviceTypeRadioChange">
              <template v-for="item in invoicesTypeDicMember">
                <van-radio :name="item.value" :key="item.value">{{
                  item.name
                  }}</van-radio>
              </template>
            </van-radio-group>
          </template>
        </van-field>

        <van-field v-if="this.memberInfo.memberCategory == 1" label="抬头类型">
          <template #input>
            <van-radio-group v-model="dialogInvoiceForm.titleType" direction="horizontal" @change="headUpType">
              <template v-for="item in TITLETYPE1">
                <van-radio :key="item.id" :name="item.value">{{
                  item.name
                  }}</van-radio>
              </template>
            </van-radio-group>
          </template>
        </van-field>

        <van-field v-if="this.memberInfo.memberCategory == 2" label="抬头类型">
          <template #input>
            <van-radio-group v-model="dialogInvoiceForm.titleType" direction="horizontal" @change="headUpType">
              <template v-for="item in TITLETYPE2">
                <van-radio :key="item.id" :name="item.value">{{
                  item.name
                  }}</van-radio>
              </template>
            </van-radio-group>
          </template>
        </van-field>
        <div v-if="this.memberInfo.memberCategory == 1"
          style="color:red;font-size: 0.4rem;margin-top:10px;font-weight: 600">
          个人会员只能开个人抬头的发票，请勿填写单位抬头</div>
        <van-field label="发票抬头" required v-model="dialogInvoiceForm.companyName" input-align="right"
          placeholder="请输入发票抬头" />
        <van-field v-model="dialogInvoiceForm.tin" required name="纳税识别号" label="纳税识别号" input-align="right"
          v-if="this.dialogInvoiceForm.titleType == 2" placeholder="请输入纳税识别号" />
        <van-field label="发票内容" v-model="contentName" input-align="right" disabled />
        <van-field label="发票金额" v-model="dialogInvoiceForm.amount" placeholder="根据缴费金额自动生成" input-align="right"
          disabled>
          <template #button v-if="dialogInvoiceForm.amount">元</template>
        </van-field>
        <van-field label="收票人邮箱" required v-model="dialogInvoiceForm.email" input-align="right"
          placeholder="请输入收票人邮箱" />
      </div>
      <div style="margin:40px auto; width:60%">
        <van-button type="primary" block @click="submitCreate">提交</van-button>
      </div>
    </div>
    <!-- 弹窗 -->
    <van-action-sheet v-model="show" :actions="options" @select="choiceOfYears" title="请选择缴费年数">
    </van-action-sheet>
    <!-- 选择弹窗 -->
    <van-popup v-model="selectModel" position="bottom" :style="{ 'min-height': '20%' }">
      <van-picker show-toolbar ref="picker" :value-key="key" :columns="columns" @change="onChange" @cancel="onCancel"
        @confirm="onConfirm" />
    </van-popup>
  </div>
</template>

<script type="text/javascript">
  import vHead from "../../components/Subhead.vue";

  import { mapState, mapGetters, mapActions } from "vuex";
  import {
    Uploader,
    Toast,
    Picker,
    Field,
    Button,
    DatetimePicker,
    Popup,
    Cell,
    CellGroup,
    ActionSheet,
    Dialog,
    RadioGroup,
    Radio,
  } from "vant";
  import {
    getDictionaryByCode,
    getUser,
    getDuesList,
    getGroupDues,
    memberAudit,
    createOrder,
    getBranchs
  } from "@/api/dictionary";
  import { getSessionStore } from "@/utils/sessionStorage.js";
  export default {
    data() {
      return {
        show: false,
        title: "缴纳会费",
        options: [],
        params: {
          years: "请选择缴费年数",
          amount: "",
          price: null,
          invoiceType: 1,
          contentType: 1,
          deliveryType: 3
        },
        key: "name",
        customDataList: {},
        columns: [],
        contentName: "会费",
        dialogInvoiceForm: {
          orderId: "",
          // 发票信息
          id: "",
          tid: "", //租户Id
          invoiceType: 1, //发票类型
          titleType: 1, //抬头类型
          companyName: "", //公司名称
          contentType: 1, //发票内容
          amount: "", //金额
          deliveryType: 3, //取票方式
          bank: "", //开户银行
          account: "", //银行账户
          // 地址信息
          province: "", //省
          city: "", //市
          contact: "", //联系人
          mobile: "", //联系电话
          detailedAddress: "", //详细地址
          zipcode: "", //邮编
          code: "",
          email: "",
          tin: "",
        },
        selectKey: '',
        selectModel: false,
        invoiceApplyradio: "1",
        invoiceApplyradioEnum: [
          {
            name: "否",
            value: "1",
          },
          {
            name: "是",
            value: "2",
          },
        ],
        TITLETYPE1: [{ name: '个人', value: 1, code: "PERSONAL" }],
        TITLETYPE2: [{ name: '单位', value: 2, code: "COMPANY" }],
        yearsName: ''
      };
    },
    components: {
      vHead,
      [Uploader.name]: Uploader,
      [Toast.name]: Toast,
      [Field.name]: Field,
      [Button.name]: Button,
      [DatetimePicker.name]: DatetimePicker,
      [Popup.name]: Popup,
      [CellGroup.name]: CellGroup,
      [Cell.name]: Cell,
      [Picker.name]: Picker,
      [ActionSheet.name]: ActionSheet,
      [Dialog.Component.name]: Dialog.Component,
      [Radio.name]: Radio,
      [RadioGroup.name]: RadioGroup,
    },
    computed: {
      ...mapGetters(["isGroupMember", "dictFromCode"]),
      ...mapState(["userInfo"]),
      invoicesTypeDicMember() {
        return this.dictFromCode("INVOICE_TYPE_MEMBER");
      },
      invoicesTitleTypeList() {
        return this.dictFromCode("TITLE_TYPE");
      },
    },
    methods: {
      ...mapActions(["getDictionaryList"]),
      onChange(picker, values, index) {
        // if (this.selectKey === "title") {
        //   picker.setColumnValues(1, values[0].children);
        // } else if (this.selectKey === "jg" || this.selectKey === "province") {
        //   let city = this.allAddress.filter((item) => {
        //     return item.parentId === values[0].id;
        //   });
        //   if (index === 0) {
        //     picker.setColumnValues(1, city);
        //   }
        // }
      },

      onCancel() {
        this.selectModel = false;
        this.selectKey = undefined;
      },
      onConfirm(item) {
        this.selectModel = false;
        var fieldVal;
        this.params["recommendUnitId"] = item.code;
        this.params["recommendUnitIdParent"] = item.branchType;
        // this.pickerField.value = fieldVal;
        // this.pickerField.displayValue = item.name;
        // this.pickerField = undefined;
        // this.dateField = undefined;
        this.selectKey = undefined;
      },
      getRecommendBranchName(value) {
        let name = "";
        if (value && this.customDataList["recommendUnitId"]) {
          let obj = this.customDataList["recommendUnitId"].find(
            (item) => item.code === value
          );
          if (obj) {
            return obj.name;
          } else {
            return "";
          }
        }
        return name;
      },
      choiceOfYears(data) {
        this.params.amount = this.params.price * data.value;
        this.params.years = data.value;
        this.yearsName = data.name
        this.dialogInvoiceForm.amount = this.params.amount;
        this.show = false;
      },
      changeInvoiceApplyRadio(val) {
        this.invoiceApplyradio = val;
        this.dialogInvoiceForm.email = this.memberInfo.email
          ? this.memberInfo.email
          : "";
        this.dialogInvoiceForm.companyName = this.memberInfo.name ? this.memberInfo.name
          : "";

      },
      showRecommendBranchPicker(pickerField, dateField) {
        this.selectModel = true;
        this.selectKey = "recommendUnitId";
        this.columns = this.customDataList["recommendUnitId"];
        // this.pickerField = pickerField;
      },
      submitCreate() {
        if (this.params.amount == "0") {
          Toast('缴费金额不能为0');
          return
        }
        if (!this.params.amount && this.userInfo.memberType != 3) {
          Toast("请选择缴费年数");
          return;
        }

        if (this.invoiceApplyradio == "2") {
          if (!this.dialogInvoiceForm.companyName) {
            Toast("发票抬头不能为空");
            return;
          }
          if (this.dialogInvoiceForm.titleType == 2) {
            if (!this.dialogInvoiceForm.tin) {
              Toast("纳税识别号不能为空");
              return;
            }
          }
          if (!this.dialogInvoiceForm.email) {
            Toast("收票人邮箱不能为空");
            return;
          }
        }
        this.create();
      },

      create() {
        getUser().then((res) => {
          if (9 == res.result.memberCategory) {
            Toast("请先申请成为会员再缴纳会费!");
            return;
          } else {
            this.params.invoiceApplyradio = this.invoiceApplyradio;
            if (this.invoiceApplyradio == 2) {
              this.params.titleType = this.dialogInvoiceForm.titleType;
              this.params.tin = this.dialogInvoiceForm.tin;
              this.params.invoiceApplyradio = this.invoiceApplyradio;
              this.params.companyName = this.dialogInvoiceForm.companyName;
              this.params.contentName = 1;
              this.params.email = this.dialogInvoiceForm.email;
            }
            this.params.access_token = getSessionStore("access_token");
            if (this.params.amount == "0") {
              Toast.fail('缴费金额不能为0');
            } else {
              createOrder(this.params).then((res) => {
                if (res.success) {
                  Toast.success("添加订单成功！");
                  this.$router.push({ name: "PaymentList" });
                } else {
                  Toast.fail(res.message);
                }
              });
            }

          }
        });
      },

      onInoviceTypeRadioChange: function (value) {
        if (value == 1) {
          this.dialogInvoiceForm.titleType = 1;
          this.company = false;
        } else {
          this.dialogInvoiceForm.titleType = 2;
          this.company = true;
        }
      },
      headUpType(label) {
        if (label == 2) {
          this.dialogInvoiceForm.titleType = 2;
        } else {
          this.dialogInvoiceForm.titleType = 1;
        }
        this.dialogInvoiceForm.amount = this.params.amount;
      },
      getMemberDues() {
        if (this.memberInfo.memberCategory == 1) {
          getDuesList().then((res) => {
            if (res.success) {
              this.memberDues = res.result;
              const dues = this.memberDues.filter((item) => {
                return item.memberType === this.memberInfo.memberType;
              });
              this.params.price = dues[0].amount;
            }
          });
        } else {
          getGroupDues().then((res) => {
            if (res.success) {
              this.groupDues = res.result;
              const dues = this.groupDues.filter((item) => {
                return item.memberType === this.memberInfo.memberType;
              });
              this.params.price = dues[0].amount;
            }
          });
        }
      },

    },
    created() {
      getBranchs().then((res) => {
        if (res.success) {
          res.result.forEach((itm) => (itm.value = itm.code));
          this.customDataList["recommendUnitId"] = res.result;
          this.customDataList["concernUnitId"] = res.result;
        }
      });
    },
    mounted() {
      this.getDictionaryList();
      getUser().then((res) => {
        this.memberInfo = res.result;
        this.params.recommendUnitIdParent = res.result.recommendUnitIdParent
        this.params.recommendUnitId = res.result.recommendUnitId
        this.dialogInvoiceForm.companyName = res.result.name
        this.dialogInvoiceForm.email = res.result.email
        if (this.userInfo.memberCategory == 2) {
          this.headUpType(2)
        }
        if (this.userInfo.memberCategory == 1) {
          this.headUpType(1)
        }
      });
      setTimeout(this.getMemberDues, 1000);
      getDictionaryByCode("ORDER_YEARS").then((res) => {
        if (res.success) {
          this.options = res.result;
        }
      });
    },
  };
</script>

<style type="text/css" lang="less" scoped>
  .contentOffLine {
    padding: 20px 18px;

    .van-cell {
      padding: 15px 0;
    }

    .van-cell--required::before {
      display: none;
    }

    /deep/.van-cell--required .van-cell__title::after {
      position: absolute;
      color: #ee0a24;
      font-size: 0.37333rem;
      content: "\00A0*";
    }
  }

  .cellRoadDiv>div {
    display: flex;
    justify-content: space-between;
    align-content: center;
  }

  /deep/.van-field__control--custom {
    justify-content: flex-end;
  }

  .cellRoadDiv /deep/.van-radio__icon {
    display: none;
  }

  .cellRoadDiv .fontSix {
    text-align: right;
    font-size: 0.4rem;
    color: #646566;
  }
</style>